import { render, staticRenderFns } from "./TagUpdateModal.vue?vue&type=template&id=463c3c37&"
import script from "./TagUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TagUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports